import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import _filter from 'lodash/filter';

const getAnswer = (state) => (ansId) => {
  // if (ansId.key === 'question_sub') console.log('getter getAnswer', ansId);
  return _find(state.answers, (o) => {
    // if (ansId.key === 'question_sub') console.log(500, o[ansId.key], ansId.value);
    return o[ansId.key] === ansId.value;
  });
};

const getAnswersByPoll = (state) => (pollId) => {
  return _filter(state.answers, (o) => {
    return o.pollId === pollId;
  });
};

const getAnswerIndex = (state) => (ansId) => {
  // console.log('getter getAnswer idx', ansId);
  return _findIndex(state.answers, (o) => {
    return o[ansId.key] === ansId.value;
  });
};

const getExelLink = (state) => {
  return state.exelLink;
};

export default {
  getAnswer,
  getAnswerIndex,
  getAnswersByPoll,
  getExelLink
};
